import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        if (this.element.nodeName === 'SELECT') {
            this.element.addEventListener('change', () => {
                this.toggleSelect();
            });
            this.toggleSelect();
        } else if (this.element.nodeName === 'INPUT' && this.element.type.toLowerCase() === 'checkbox') {
            this.element.addEventListener('change', () => {
                this.toggleCheckBox();
            });
            this.toggleCheckBox();
        } else {
            this.element.addEventListener('click', () => {
                this.toggleElement();
            });
        }
    }

    toggleElement() {
        const name = this.element.querySelector(`[data-toggler]`).getAttribute('data-toggler');
        document.querySelectorAll(`[data-toggle=${name}]`).forEach(function(elm) {
            const display = elm.currentStyle ? elm.currentStyle.display : getComputedStyle(elm, null).display;
            if (display === 'none') {
                elm.classList.add('d-block');
            } else {
                elm.classList.remove('d-block');
            }
        });
    }

    toggleCheckBox() {
        const checked = this.element.checked;
        const name = this.element.name;
        if (checked) {
            document.querySelectorAll(`[data-toggle=${name}]`).forEach(function(opt) {
                opt.classList.remove('d-none');
            });
        } else {
            document.querySelectorAll(`[data-toggle=${name}]`).forEach(function(opt) {
                opt.classList.add('d-none');
            });
        }
    }

    toggleSelect() {
        const options = this.element.options;
        for (const option of options) {
            if (option.value && option.hasAttribute('value')) {
                document.querySelectorAll(`.${option.value}`).forEach(function(opt) {
                    opt.classList.add('d-none');
                });
            }
        }

        const option = options[this.element.selectedIndex];
        if (option.value && option.hasAttribute('value')) {
            document.querySelectorAll(`.${option.value}`).forEach(function(opt) {
                opt.classList.remove('d-none');
            });
        }
    }
}